import { render, staticRenderFns } from "./LoginOptionDialog.vue?vue&type=template&id=0c8f573d&scoped=true&"
import script from "./LoginOptionDialog.vue?vue&type=script&lang=js&"
export * from "./LoginOptionDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoginOptionDialog.vue?vue&type=style&index=0&id=0c8f573d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f573d",
  null
  
)

export default component.exports